<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 14 14">
    <path d="M11.898 10.461c-0.203-1.461-0.797-2.758-2.125-2.937-0.688 0.75-1.68 1.227-2.773 1.227s-2.086-0.477-2.773-1.227c-1.328 0.18-1.922 1.477-2.125 2.937 1.086 1.531 2.875 2.539 4.898 2.539s3.812-1.008 4.898-2.539zM10 5c0-1.656-1.344-3-3-3s-3 1.344-3 3 1.344 3 3 3 3-1.344 3-3zM14 7c0 3.852-3.125 7-7 7-3.867 0-7-3.141-7-7 0-3.867 3.133-7 7-7s7 3.133 7 7z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-user-circle.html